import React from "react";
import "./LoadingSpinner.css";

type Size = "small" | "medium" | "large";
type Color = "primary" | "secondary" | "neutral" | string;

interface LoadingSpinnerProps {
  size?: Size;
  color?: Color;
  message?: string;
  overlay?: boolean;
  fullscreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "medium",
  color = "primary",
  message = "",
  overlay = false,
  fullscreen = false,
}) => {
  const sizeClass = `spinner-${size}`;
  const colorClass = `spinner-${color}`;

  const spinner = (
    <div className={`loading-spinner ${sizeClass} ${colorClass}`}>
      <div className="spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );

  if (fullscreen) {
    return <div className="loading-fullscreen">{spinner}</div>;
  }

  if (overlay) {
    return <div className="loading-overlay">{spinner}</div>;
  }

  return spinner;
};

export default LoadingSpinner;
